import { IAdminProjectsState } from '../../../types/store/admin/projects';

export const initState: IAdminProjectsState = {
  pendingProjects: null,
  isPendingProjectsLoading: false,
  project: null,
};
